export enum ProjectDataViewModes {
  encodedData = "",
  textData = "text-data",
  integrations = "integrations",
  oeCoding = "oe-coding",
  aiCoding = "ai-coding",
}
